import {
    IconChartBarPopular,
    IconChartHistogram,
    IconHome,
    IconBarbell,
    IconUsersGroup,
  } from '@tabler/icons-react';
  import React, { useMemo } from 'react';
  import { Link, useLocation } from 'react-router-dom';
  import { useLanguage } from '../context/LanguageContext';
  import { useDashboard } from '../hooks/useDashboard';
  
  const Footer: React.FC = () => {
    const location = useLocation();
    const { translate } = useLanguage();
    const { data: dashboardData } = useDashboard();

    const tabs = useMemo(() => {
      const baseTabs = [
        { name: translate('dashboard'),   path: '/dashboard',  icon: <IconHome /> },
        { name: translate('training'),     path: '/trening',    icon: <IconBarbell /> },
      ];

      if (dashboardData?.studio.canUseGroupClasses) {
        baseTabs.push({ name: translate('classes'), path: '/zajecia', icon: <IconUsersGroup /> });
      }

      baseTabs.push(
        { name: translate('ranking'),     path: '/ranking',    icon: <IconChartBarPopular /> },
        { name: translate('statistics'),  path: '/statystyki', icon: <IconChartHistogram /> },
      );

      return baseTabs;
    }, [translate, dashboardData?.studio.canUseGroupClasses]);

    const gridCols = tabs.length === 5 ? 'grid-cols-5' : 'grid-cols-4';
  
    return (
      <div className="fixed bottom-0 left-0 z-50 w-full h-16 bg-custom36p">
        <div className={`grid h-full max-w-lg ${gridCols} mx-auto font-medium`}>
          {tabs.map((tab) => {
            const isActive = location.pathname === tab.path || location.pathname.startsWith(`${tab.path}/`);          
            return (
              <Link
                key={tab.path}
                to={tab.path}
                className={`
                  inline-flex flex-col items-center justify-center group
                  focus:outline-none focus:ring-3 focus:ring-custom36p
                  ${isActive ? "bg-gradient-to-t from-custom36s to-custom36s/55" : ""}
                  hover:bg-gradient-to-t hover:from-custom36s hover:to-custom36s/55
                `}
              >
                <div
                  className={`
                    flex flex-col items-center justify-center w-full h-full
                    transition-colors duration-200
                    ${
                      isActive
                        ? "bg-transparent"
                        : "bg-custom36p group-hover:bg-transparent"
                    }
                  `}
                >
                  <div className="mb-1">
                    {React.cloneElement(tab.icon, {
                      className: `w-7 h-7 ${
                        isActive
                          ? "text-white"
                          : "text-gray-200"
                      } group-hover:text-white`,
                    })}
                  </div>
                  <span
                    className={`text-xs font-bold ${
                      isActive
                        ? "text-white"
                        : "text-gray-200 "
                    } group-hover:text-white`}
                  >
                    {tab.name}
                  </span>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    );
  };
  
  export default Footer;
